export function createDivWithId(id: string) {
  const newDiv = document.createElement("div");
  newDiv.id = id;
  return newDiv;
}
